import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import environment from "web/script/modules/environment";
import browser from "web/script/utils/browser";
import withReduxProvider from "web/react/redux-provider";
import ProfileHeaderWithLogo from "web/react/components/profile-header/profile-header-with-logo";
import ProfileHeaderBaustein from "web/react/components/profile-header/profile-header-baustein";
import { triggerBanner, setDesignerProfile } from "web/redux/ducks/follow-designer-banner";
import { ReduxStoreState } from "web/redux/store";

export interface ProfileHeaderProps {
    profile: {
        follow_button?: {
            lyst_id: number;
            registration_reason?: string;
            followed_text: string;
            notfollowed_text: string;
            notfollowed_text_top: string;
            is_authenticated: string;
            is_following: string;
            description: string;
            ios_sticky_description: string;
        };
        small_photo_url: string;
        name?: string;
        title?: string;
        retailer_hub_link?: string;
        brand_ad?: {
            banner_image: string;
            brand_logo: string;
            brand_name: string;
            link: string;
            mpu_image: string;
            product_image?: string;
            product_link?: string;
            product_description?: string;
        };
        features?: {
            pmt_brand_ads?: boolean;
        };
    };
    shopHeader?: boolean;
}

function extractState(state: ReduxStoreState): boolean {
    return state.appDownloadBannerReducer.isVisible;
}

function getInView(bounding: DOMRect): boolean {
    return (
        bounding.top >= -bounding.height &&
        bounding.left >= -bounding.width &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

export function ProfileHeader({ profile, shopHeader }: ProfileHeaderProps): JSX.Element {
    const followCTARef = useRef<HTMLDivElement>(null);
    const [isIos, setIsIos] = useState(false);
    const dispatch = useDispatch();
    const appBannerIsVisible = useReduxSelector(extractState);

    dispatch(setDesignerProfile(profile));

    useEffect(() => {
        function onScroll(): void {
            if (followCTARef.current) {
                let bounding = followCTARef.current.getBoundingClientRect();
                dispatch(triggerBanner(!getInView(bounding)));
            }
        }
        window.addEventListener("scroll", onScroll);
        return (): void => {
            window.removeEventListener("scroll", onScroll);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (followCTARef.current) {
            let bounding = followCTARef.current.getBoundingClientRect();
            dispatch(triggerBanner(!getInView(bounding)));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [followCTARef.current]);

    useEffect(() => {
        setIsIos(browser.ios);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [browser.ios]);

    const pageSubType = environment.get("pageSubType");
    const designerLogoOnSmallScreens =
        environment.getFeature("mg_hide_du_banner_if_du_cta_in_view") ||
        (environment.getFeature("mg_du_banner_ios_to_app") && pageSubType.startsWith("designer"));
    let title = shopHeader ? profile.title : profile.name;

    if (!title) {
        return <></>;
    } else if (designerLogoOnSmallScreens) {
        return (
            <ProfileHeaderWithLogo
                title={title}
                profile={profile}
                followCTARef={followCTARef}
                isIos={isIos}
                isShopHeader={shopHeader}
                appBannerIsVisible={appBannerIsVisible}
            />
        );
    } else {
        return (
            <>
                <ProfileHeaderBaustein
                    profile={profile}
                    isShopHeader={shopHeader}
                    designerLogoOnSmallScreens={false}
                    appBannerIsVisible={appBannerIsVisible}
                />
            </>
        );
    }
}

export default withReduxProvider(ProfileHeader);
